import React, { useState, useEffect } from "react";
import { Segment, Tab } from "semantic-ui-react";
import Tables from "./Tables";
import {  getTableInfo } from "../../features/tableData/visualSlice"
import { useSelector } from "react-redux";

export default function ViewData() {
    const [panes, setPanes] = useState([]);
    const tableInfo = useSelector(getTableInfo);
    const [activeTabIndex, setActiveTabIndex] = useState(-1);
   
    useEffect(() => {
      // console.log("in use effect")
      const newPanes = [];
      console.log(tableInfo);
      if(tableInfo.payload !== undefined) {
        newPanes.push({
          menuItem: tableInfo.schema.tableData.title,
          render: () => <>
              <Segment inverted>{"Table Description: " + tableInfo.description}</Segment>
              <Tables headers={tableInfo.schema.tableData.headers} data={tableInfo.schema.tableData.data}/>
            </>
        });
        newPanes.push({
          menuItem: tableInfo.payload.tableData.title,
          render: () => <Tables headers={tableInfo.payload.tableData.headers} data={tableInfo.payload.tableData.data}/>
        });
        setActiveTabIndex(0);
      }
      setPanes(newPanes);
    }, [tableInfo]);

    const changeTab = (e,data) => {
      // console.log(data);
      setActiveTabIndex(data.activeIndex);
    }
  
  return (
    <div>
      <Tab panes={panes} activeIndex={activeTabIndex} onTabChange={changeTab}/>
    </div>
  );
}
